import React from "react";
import { Badge, Button, Card, Empty, Tag, Typography } from "@douyinfe/semi-ui";
import { AiCoachResistance } from "../../../api/aiCoach";
import { radius, sp } from "../styles";

const { Title, Text, Paragraph } = Typography;

interface Props {
  items: AiCoachResistance[];
  /** 点某条抗拒点的"查看客户"按钮 */
  onBreakdown?: (term: string) => void;
}

const ResistanceList: React.FC<Props> = ({ items, onBreakdown }) => {
  if (!items || items.length === 0) return null;

  return (
    <Card
      style={{ marginBottom: sp.lg, borderRadius: radius.md }}
      bodyStyle={{ padding: sp.lg }}
    >
      <div style={{ marginBottom: sp.md, display: "flex", alignItems: "center", gap: sp.sm }}>
        <Title heading={5} style={{ margin: 0 }}>
          TOP 抗拒点
        </Title>
        <Text type="tertiary" size="small">
          共 {items.length} 类
        </Text>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: sp.md }}>
        {items.map((r, i) => (
          <div
            key={i}
            style={{
              padding: sp.md,
              background: "var(--semi-color-fill-0)",
              borderRadius: radius.sm,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: sp.sm, marginBottom: sp.sm }}>
              <Tag color="red" size="small">
                {r.category}
              </Tag>
              <Text strong style={{ fontSize: 15 }}>
                {r.term}
              </Text>
              <Badge
                count={r.frequency}
                type="danger"
                style={{ marginLeft: "auto" }}
              />
              {/* {onBreakdown && (
                <Button
                  size="small"
                  theme="borderless"
                  type="primary"
                  onClick={() => onBreakdown(r.term)}
                >
                  查看客户
                </Button>
              )} */}
            </div>

            {r.rawExamples && r.rawExamples.length > 0 && (
              <div
                style={{
                  padding: `${sp.xs} ${sp.md}`,
                  marginBottom: r.script ? sp.md : 0,
                  borderLeft: "2px solid var(--semi-color-border)",
                  color: "var(--semi-color-text-2)",
                  fontSize: 13,
                  lineHeight: 1.7,
                }}
              >
                {r.rawExamples.map((ex, idx) => (
                  <div key={idx}>“{ex}”</div>
                ))}
              </div>
            )}

            {r.script && (
              <div
                style={{
                  padding: sp.md,
                  background: "var(--semi-color-success-light-default)",
                  borderRadius: radius.sm,
                }}
              >
                <Text strong style={{ color: "var(--semi-color-success)" }}>
                  💬 建议话术
                </Text>
                <Paragraph style={{ margin: `${sp.xs} 0 0`, lineHeight: 1.7 }}>
                  {r.script}
                </Paragraph>
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ResistanceList;
